import { getContext } from '@fiverr-private/fiverr_context';
import { ROLLOUTS, EXPERIMENTS } from '@fiverr-private/listing_experiments';
import { LoyaltyProgramTier } from '@fiverr-private/loyalty_utils';
import {
    LOYALTY_UPGRADE_TO_PRO_BANNER_SHOWN_ON_LISTINGS_AND_EXPIRE_AFTER,
    GOLD_TIER_THRESHOLD_CENTS,
    PLATINUM_TIER_THRESHOLD_CENTS,
} from './consts';

const isTierReached = ({ tier, currentYearlySpendInCents, desiredTier, threshold }): boolean =>
    tier === desiredTier && currentYearlySpendInCents >= threshold;

export const shouldShowJoinProRewardsProgramBanner = (
    userLoyaltyProgramStatus: { tier: LoyaltyProgramTier; currentYearlySpendInCents: number },
    rollouts: { [key: string]: boolean }
) => {
    const { abTests } = getContext();
    const inTestGroup = Number(abTests[EXPERIMENTS.DOLPHINS_LOYALTY_ELIGIBILITY_CELEBRATION_MIGRATION]) === 2;
    const inRollout = rollouts[ROLLOUTS.DOLPHINS_LOYALTY_ELIGIBILITY_PRO_MIGRATION_BANNER];

    if (!userLoyaltyProgramStatus || !inRollout) {
        return false;
    }

    const goldTierAlreadyReached = isTierReached({
        tier: userLoyaltyProgramStatus.tier,
        currentYearlySpendInCents: userLoyaltyProgramStatus.currentYearlySpendInCents,
        desiredTier: LoyaltyProgramTier.GOLD,
        threshold: GOLD_TIER_THRESHOLD_CENTS,
    });
    const platinumTierAlreadyReached = isTierReached({
        tier: userLoyaltyProgramStatus.tier,
        currentYearlySpendInCents: userLoyaltyProgramStatus.currentYearlySpendInCents,
        desiredTier: LoyaltyProgramTier.PLATINUM,
        threshold: PLATINUM_TIER_THRESHOLD_CENTS,
    });

    const tierAlreadyReached = goldTierAlreadyReached || platinumTierAlreadyReached;

    const previousDisplayExpireAfter =
        typeof window === 'undefined' || !window.localStorage
            ? 0
            : Number(localStorage.getItem(LOYALTY_UPGRADE_TO_PRO_BANNER_SHOWN_ON_LISTINGS_AND_EXPIRE_AFTER) || 0);

    const currentTimestamp = new Date().getTime();
    return currentTimestamp > previousDisplayExpireAfter && inTestGroup && tierAlreadyReached;
};
